import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { SerialCreditApplicationRequest, SerialCreditApplicationResponse } from '../models/models'

export class AddDocumentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'compay-payment/AddDocument',
      requesterInfo,
    })
  }
  public async addDocument(req: any): Promise<boolean> {
    return await this.postAsync<boolean>(req)
  }
}
